import { alpha, styled } from '@mui/material';
import { TreeItem, type TreeItemProps, treeItemClasses } from '@mui/x-tree-view-pro';

import type { ExtraItemProps } from '../../types';

export const TREE_ITEM_MIN_HEIGHT = 40;

/** Strip custom slot props before passing the remainder to MUI `TreeItem`. */
export function stripExtraItemProps(props: TreeItemProps & ExtraItemProps): TreeItemProps {
  /* eslint-disable @typescript-eslint/no-unused-vars -- intentional omit */
  const {
    itemMetaMap,
    callbacks,
    onShowMore,
    nodeIcon,
    nodeName,
    isMoveMode,
    selectedMoveNodeId,
    selectedParentId,
    onSelectParent,
    disabledParentTreeId,
    loadingParentIds,
    testIdScope,
    ...treeItemProps
  } = props;
  /* eslint-enable @typescript-eslint/no-unused-vars */
  return treeItemProps;
}

export const CustomTreeItemStyled = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.content}`]: {
    minHeight: TREE_ITEM_MIN_HEIGHT,
    padding: theme.spacing(0, 0.5),
    margin: theme.spacing(0.1, 0),
    borderRadius: theme.shape.borderRadius
  },
  [`& .${treeItemClasses.iconContainer}`]: {
    padding: theme.spacing(0, 0.5)
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginLeft: 12,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.divider, 0.4)}`
  },
  '&[data-move-selected="true"]': {
    [`& > .${treeItemClasses.content}`]: {
      backgroundColor: theme.palette.action.selected,
      outline: `1px solid ${theme.palette.primary.main}`
    }
  },
  '& .tree-item-actions': {
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 120ms ease-in-out'
  },
  [`& .${treeItemClasses.content}:hover .tree-item-actions, & .${treeItemClasses.content}:focus-within .tree-item-actions`]:
    {
      opacity: 1,
      pointerEvents: 'auto'
    },
  '&[data-menu-open="true"] .tree-item-actions': {
    opacity: 1,
    pointerEvents: 'auto'
  }
}));
